export const customObjectProvisioningStateMapKey = "customObjectProvisioningStateMapKey";
